module.exports = __webpack_public_path__ + "static/media/13.ca6ef787.jpg";